const DRAFT_KEY_PREFIX = 'equipmentNewUnitDraft:';
const DRAFT_VERSION = 1;

export type EquipmentNewUnitDraftSnapshot = {
    version: number;
    savedAt: number;
    formData: Record<string, unknown>;
    newUnitInspectionFormId: string;
    pendingCategoryName: string | null;
    /** Query categoryId when the draft was saved (for restore routing). */
    queryCategoryId: string | null;
};

export function equipmentNewUnitDraftKey(companyId?: string | null, userId?: string | null): string {
    const companyPart = companyId || 'no-company';
    if (userId) return `${DRAFT_KEY_PREFIX}${companyPart}:${userId}`;
    return `${DRAFT_KEY_PREFIX}${companyPart}`;
}

/** Drops pre-user-scoped leftovers so another login in the same tab cannot restore them. */
export function clearSharedEquipmentNewUnitDrafts(companyId?: string | null): void {
    clearEquipmentNewUnitDraft(equipmentNewUnitDraftKey(companyId));
    if (companyId) {
        clearEquipmentNewUnitDraft(equipmentNewUnitDraftKey(null));
    }
}

export function readEquipmentNewUnitDraft(key: string): EquipmentNewUnitDraftSnapshot | null {
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as EquipmentNewUnitDraftSnapshot;
        if (parsed?.version !== DRAFT_VERSION || typeof parsed.formData !== 'object' || !parsed.formData) {
            return null;
        }
        return parsed;
    } catch {
        return null;
    }
}

export function writeEquipmentNewUnitDraft(
    key: string,
    draft: Omit<EquipmentNewUnitDraftSnapshot, 'version' | 'savedAt'>,
): void {
    try {
        const payload: EquipmentNewUnitDraftSnapshot = {
            ...draft,
            version: DRAFT_VERSION,
            savedAt: Date.now(),
        };
        sessionStorage.setItem(key, JSON.stringify(payload));
    } catch {
        // Quota / private mode — best-effort.
    }
}

export function clearEquipmentNewUnitDraft(key: string): void {
    try {
        sessionStorage.removeItem(key);
    } catch {
        // ignore
    }
}
